<template>
  <a-modal
      title="学校二维码"
      :width="640"
      v-model="visible"
      :bodyStyle="{ maxHeight: '700px', overflowY: 'auto' }"
  >
    <div class="qrcode-container">
      <div class="qrcode-wrapper">
        <div class="qrcode-image-container">
          <a-spin :spinning="loading" size="large">
            <div class="spin-wrapper">
              <img
                  :src="qrcodeUrl"
                  :alt="bizOrgName + '二维码'"
                  class="qrcode-image"
                  v-if="!loading && qrcodeUrl"
              />
              <img
                  src=""
                  :alt="bizOrgName + '二维码'"
                  class="qrcode-image"
                  v-else-if="!loading"
              />
            </div>
          </a-spin>
        </div>
        <div class="qrcode-name">{{ '扫码加入：' + bizOrgName + ' 校园洗衣中心' }}</div>
      </div>
    </div>
    <template #footer>
      <a-button key="submit" type="primary" @click="handleSubmit">
        确定
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import bizOrgService from '@/service/bizOrg'

export default {
  data() {
    return {
      labelCol: {
        xs: {span: 24},
        sm: {span: 7}
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 13}
      },
      visible: false,
      bizOrgName: '',
      qrcodeUrl: '',
      loading: true
    }
  },
  props: {
    formType: ''
  },
  methods: {
    showModal(id, name, type) {
      this.visible = true
      this.bizOrgName = name
      this.loading = true
      this.qrcodeUrl = ''

      // 模拟从服务器获取二维码URL
      if (type === 'qrcode') {
        this.fetchQrCodeUrl(id)
      } else {
        this.fetchMiniCodeUrl(id)
      }
    },

    handleSubmit() {
      this.visible = false
    },

    fetchQrCodeUrl(id) {
      bizOrgService.getQrCode({id}).then(res => {
        this.qrcodeUrl = res.data
        this.loading = false
      }).catch(err => {
        this.qrcodeUrl = ''
        this.loading = false
      })
    },
    fetchMiniCodeUrl(id) {
      bizOrgService.getMiniCode({id}).then(res => {
        this.qrcodeUrl = `data:image/png;base64,${res.data}`
        this.loading = false
      }).catch(err => {
        this.qrcodeUrl = ''
        this.loading = false
      })
    },
  },
}
</script>

<style scoped>
.ant-form-item {
  margin-bottom: 2px;
}

.qrcode-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}

.qrcode-wrapper {
  text-align: center;
  width: 100%;
}

.qrcode-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 280px;
}

.spin-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 250px;
  height: 250px;
}

.qrcode-image {
  width: 250px;
  height: 250px;
  object-fit: contain;
  margin-bottom: 16px;
}

.qrcode-name {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-top: 10px;
}
</style>
